import d from"styled-components";const o=d.div`
	border-radius: ${({borderRadius:d})=>"number"==typeof d?d:14}px;
	background: ${({theme:d})=>d.bg.card};
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	padding: ${({padding:d})=>d||"16px"};
`;export{o as SpaceContainer};
